module.exports = __webpack_public_path__ + "img/Shanxi-speed.8f817658.png";